import { useTranslations } from 'utils/translations/useTranslations';

function EURateDisclaimer() {
  const i18n = useTranslations();

  return (
    <p className="PaymentOptions-disclaimer">
      {i18n.t('paymentOptions.disclaimer')}
    </p>
  );
}

EURateDisclaimer.displayName = 'EURateDisclaimer';

export { EURateDisclaimer };
